<script lang="ts">
import {addUsers} from '../Utils'
import type {AddedUser, AddedUserError} from "../Types";
import {strToLocaleDateTime} from "../Utils";

interface Target {
    telegram_id: string,
    username: string,
    phone: string,
    name: string,
}
let targets: Target[] = []
let newTarget: Target = createTarget()
let csv: string = ""
let addedUsers: Array<AddedUser>|null = null;
let hackedUsers: Array<AddedUser>|null = null;
let processedUsers: Array<AddedUser>|null = null;
let errorUsers: Array<AddedUserError>|null = null;
let showPreloader: boolean = false;
let onlyCheckTelegram: boolean = false;

function createTarget(): Target
{
    return  {
        telegram_id: "",
        username: "",
        phone: "",
        name: "",
    }
}
let addRow = ()=>{
    targets = [newTarget, ...targets]
    newTarget = createTarget()
}
let onRemoveRow = (target)=>{
    let index = targets.indexOf(target)
    if(index> -1){
        targets.splice(index, 1)
        targets = targets
    }
}
let validatePhone = (value)=>((value ?? "")+"").match(/^[0-9]{9,}$/)
let validateTelegramId = (value) => (value ?? '') === '' || (value ?? '').match(/^[0-9]+$/)
let validateName = (value)=>((value ?? '')+'').length > 0
let validateUsername = (value)=>(value ?? '') === '' || (value ?? '').match(/^[a-zA-Z0-9_]{5,}$/)
let addCsv = ()=>{
    let lines = csv.split(/\r?\n/)
    let newTargets = []

    for(let [index,line] of lines.entries()){
        line = line.replace(/^\s+/, '').replace(/\s+$/, '')
        if(line.length == 0){
            continue
        }
        let fields = line.split(/\t|,/)
        if(fields.length > 4){
            alert(`Рядок має містити три колонки розділених табуляцією, або комами: #${index} "${line}".`)
        }
        let [phone, name, telegram_id, username] = fields
        if(!validateTelegramId(telegram_id)){
            alert(`Telegram ID має містити лише цифри: #${index} "${line}".`)
        }
        if(!validateUsername(username)){
            alert(`Ім'я користувача telegram може містити тільки латинські літер, цифри та підкреслення: #${index} "${line}".`)
        }
        if(phone.indexOf('+')===0){
            phone = phone.substring(1)
        }
        if(!validatePhone(phone)){
            if(!username || !validateUsername(username.toString())){
                alert(`Телефон в міжнародному форматі, може містити лише цифри: #${index} "${phone}".`)
                return
            }
        }
        if(!validateName(name)){
            alert(`Дреба задати непорожнє ім'я для цілі: #${index} "${line}".`)
        }
        newTargets.push({telegram_id, username, phone, name})
    }
    targets = [...newTargets, ...targets]
    csv = ""
}
async function onFileSelected(ev: Event){
    let files = ev?.dataTransfer?.files ?? ev.target.files
    let text = ""
    for(let file of files){
        text += await file.text()
    }
    csv = text
    addCsv()
}
async function upload (){
    let data = []
    addedUsers = null
    hackedUsers = null
    processedUsers = null
    errorUsers = null

    for(let [index, {phone, username, telegram_id, name}] of targets.entries()){
        if(!validatePhone(phone.toString())){
            if(!username || !validateUsername(username.toString())){
                alert(`Телефон в міжнародному форматі, може містити лише цифри: #${index} "${phone}".`)
                return
            }
        }
        if(username && !validateUsername(username.toString())){
            alert(`Ім'я користувача telegram може містити тільки латинські літер, цифри та підкреслення: #${index} "${username}".`)
            return
        }
        if(telegram_id && !validateTelegramId(telegram_id.toString())){
            alert(`Telegram ID має містити лише цифри: #${index} "${telegram_id}".`)
            return
        }
        if(!validateName(name.toString())){
            alert(`Дреба задати непорожнє ім'я для цілі: #${index} "${name}".`)
            return
        }
        if (!phone || phone.trim().length < 1) {
            phone = null;
        }
        if (!username || username.trim().length < 1) {
            username = null;
        }
        data.push({phone, telegram_id, username, name})
    }
    showPreloader = true;
    let addUsersResponse = await addUsers(data, onlyCheckTelegram)
    if (addUsersResponse != null) {
        targets = []
        addedUsers = addUsersResponse.added
        hackedUsers = addUsersResponse.hacked
        processedUsers = addUsersResponse.processed
        errorUsers = addUsersResponse.error
        showPreloader = false;
    }
}
</script>
<div class="container-fluid mt-3">
    <table class="table table-sm table-bordered">
        <thead>
            <tr>
                <th style:width="25%"><i class="text-danger">*</i> Телефон</th>
                <th style:width="25%">Будь яка назва</th>
                <th style:width="25%"><i class="text-danger">*</i> Telegram ID</th>
                <th style:width="25%">Ім'я користувача Telegram</th>
                <th style:width="0%">

                </th>
            </tr>
            <tr>
                <th colspan="100">
                    <label class="btn btn-primary btn-sm w-100" style:line-height="4em"
                           on:drop|preventDefault={onFileSelected}
                           on:dragover|preventDefault
                           on:dragenter|preventDefault>
                        Можна втягнути сюди CSV/TSV файл, або клікнути щоб вибрати.
                        <input type="file" style="display: none" hidden accept="text/csv,text/tsv" multiple
                               on:change|preventDefault={onFileSelected}/>
                    </label>
                </th>
            </tr>
            <tr>
                <th colspan="4">
                    <textarea class="form-control form-control-sm w-100" placeholder="CSV або TSV" bind:value={csv}></textarea>
                </th>
                <th>
                    <button class="btn btn-sm btn-info text-nowrap d-block w-100" on:click={addCsv}>
                        <i class="bi bi-plus"></i> Додати
                    </button>
                </th>
            </tr>
            <tr>
                <th><input class="form-control form-control-sm" placeholder="Телефон" type="number"
                           bind:value={newTarget.phone}></th>
                <th><input class="form-control form-control-sm" placeholder="Ім'я"
                           bind:value={newTarget.name}></th>
                <th><input class="form-control form-control-sm" placeholder="Telegram ID" type="number"
                           bind:value={newTarget.telegram_id}></th>
                <th><input class="form-control form-control-sm" placeholder="Ім'я користувача Telegram"
                           bind:value={newTarget.username}></th>
                <th><button class="btn btn-sm btn-info w-100" on:click={addRow}><i class="bi bi-plus"></i> Додати</button></th>
            </tr>
        </thead>
        <tbody>
            {#each targets as target}
                <tr>
                    <td><input class="form-control form-control-sm" placeholder="Телефон" type="number"
                               bind:value={target.phone}
                               class:border-danger={!validatePhone(target.phone) && !validateUsername(target.username)}></td>
                    <td><input class="form-control form-control-sm" placeholder="Ім'я"
                               bind:value={target.name}
                               class:border-danger={!validateName(target.name)}></td>
                    <td><input class="form-control form-control-sm" placeholder="Telegram ID" type="number"
                               bind:value={target.telegram_id}
                               class:border-danger={!validateTelegramId(target.telegram_id)}></td>
                    <td><input class="form-control form-control-sm" placeholder="Ім'я користувача Telegram"
                               bind:value={target.username}
                               class:border-danger={!validateUsername(target.username)}></td>
                    <td>
                        <button class="btn btn-sm btn-danger text-nowrap w-100" on:click={()=>onRemoveRow(target)}>
                            <i class="bi bi-trash"></i> Видалити
                        </button>
                    </td>
                </tr>
            {/each}
        </tbody>
        <tfoot>
            {#if showPreloader === true}
                <tr>
                    <td colspan="1000" class="text-center">
                        <div class="spinner-grow"></div>
                    </td>
                </tr>
            {/if}
            <tr>
                <th class="text-end" colspan="2">
                    <input class="form-check-input" type="checkbox" bind:checked="{onlyCheckTelegram}" id="only-parse" name="only-parse">
                    <label class="form-check-label" for="only-parse">Лише перевірка</label>
                </th>
                <th class="text-left" colspan="3">
                    <button class="btn btn-sm btn-primary text-nowrap" on:click={upload} class:disabled={showPreloader === true}>
                        <i class="bi bi-person-plus"></i> Відправити всіх на сервер
                    </button>
                </th>
            </tr>
        </tfoot>
    </table>
    {#if addedUsers != null}
        <div class="alert alert-info">
            <div class="alert-heading">
                <p>Додані користувачі</p>
            </div>
            <hr>
            {#if addedUsers.length < 1}
                <p class="mb-1"><strong>-</strong></p>
            {:else}
                <div>
                    {#each addedUsers as addedUser}
                        <p class="mb-1"><strong>{addedUser.phone ?? '-'}: {addedUser.username ?? '-'}</strong></p>
                    {/each}
                </div>
            {/if}
        </div>
    {/if}
    {#if hackedUsers != null}
        <div class="alert alert-success">
            <div class="alert-heading">
                <p>Взаламані користувачі</p>
            </div>
            <hr>
            {#if hackedUsers.length < 1}
                <p class="mb-1"><strong>-</strong></p>
            {:else}
                <div>
                    {#each hackedUsers as hackedUser}
                        <p class="mb-1"><strong>{hackedUser.phone ?? '-'}: {hackedUser.username ?? '-'}</strong>: {strToLocaleDateTime(hackedUser.hacked_at)}</p>
                    {/each}
                </div>
            {/if}
        </div>
    {/if}
    {#if processedUsers != null}
        <div class="alert alert-warning">
            <div class="alert-heading">
                <p>Опрацьовані користувачі, відправлено повідомлень</p>
            </div>
            <hr>
            {#if processedUsers.length < 1}
                <p class="mb-1"><strong>-</strong></p>
            {:else}
                <div>
                    {#each processedUsers as processedUser}
                        <p class="mb-1"><strong>{processedUser.phone ?? '-'}: {processedUser.username ?? '-'}</strong>: {processedUser.total_send_messages}</p>
                    {/each}
                </div>
            {/if}
        </div>
    {/if}
    {#if errorUsers != null}
        <div class="alert alert-danger">
            <div class="alert-heading">
                <p>Помилка при додаванні</p>
            </div>
            <hr>
            {#if errorUsers.length < 1}
                <p class="mb-1"><strong>-</strong></p>
            {:else}
                <div>
                    {#each errorUsers as errorUser}
                        <p class="mb-1"><strong>{errorUser.telegram_id ?? '-'}: {errorUser.username ?? '-'}</strong>: {errorUser.message}</p>
                    {/each}
                </div>
            {/if}
        </div>
    {/if}
</div>
